import { Action } from '@ngrx/store';
import { UploadFile } from '../shared.model';


export const ACTIVAR_LOADING = '[UI Loading] Cargando...';
export const DESACTIVAR_LOADING = '[UI Loading] Fin de carga...';
export const SET_IDIOMA = '[UI Languaje] Set Idioma';
export const SET_FILES = '[UI Upload Files] Set Files';
export const UNSET_FILES = '[UI Upload Files] Unset Files';
export const ADD_FILE = '[UI Upload Files] Add File';
export const DELETE_FILE = '[UI Upload Files] Delete File';
export const SET_FILE_UPLOAD_COMPLETED = '[UI Upload Files] Set Completed Upload File';


export class ActivarLoadingAction implements Action {
    readonly type = ACTIVAR_LOADING;
}

export class DesactivarLoadingAction implements Action {
    readonly type = DESACTIVAR_LOADING;
}

export class SetIdiomaAction implements Action {
    readonly type = SET_IDIOMA;

    constructor(public lang: string) { }
}

export class SetFilesAction implements Action {
    readonly type = SET_FILES;

    constructor(public files: UploadFile[]) { }
}

export class AddFileAction implements Action {
    readonly type = ADD_FILE;

    constructor(public file: UploadFile) { }
}

export class UnsetFilesAction implements Action {
    readonly type = UNSET_FILES;
}

export class DeleteFileAction implements Action {
    readonly type = DELETE_FILE;

    constructor(public id: string) { }
}

export class SetCompletedFileAction implements Action {
    readonly type = SET_FILE_UPLOAD_COMPLETED;

    constructor(public id: string) { }
}

export type acciones =
    ActivarLoadingAction |
    DesactivarLoadingAction |
    SetFilesAction |
    DeleteFileAction |
    UnsetFilesAction |
    SetCompletedFileAction |
    AddFileAction |
    SetIdiomaAction;
